<div id="front-page" class="container p-5">
  <h1>Slider Text</h1>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <div class="formspace">
        <label for="pageTitle" class="required">Title (Max 100 characters)</label>
        <input
          type="text"
          class="form-control my-2"
          formControlName="pageTitle"
          placeholder="" id="pageTitle"
          aria-labelledBy="pageTitle"
          (keyup)="titleCount($event)"
          maxlength="100"
          />
        <span>
          <p>{{ form.value.pageTitle?.length }}/{{ maxTitleOfCharacters }}</p>
        </span>
      </div>
      <div class="mt-5">
        <label for="editorContent" class="form-label required">Description (Max 500 characters)</label>
        <textarea
          class="form-control mt-2"
          formControlName="editorContent"
          cols="100"
          rows="8"
          maxlength="500"
          aria-labelledBy="Description"
          (keyup)="descriptionCount($event)"
        ></textarea>
        <span>
          <p>
            {{ form.value.editorContent?.length }}/{{ maxNumberOfDescripCharacters }}
          </p>
        </span>
      </div>
    </div>
    <div class="center mt-5">
      <button type="submit" class="btn btn-primary mb-3" aria-label="update">
        Update
      </button>
    </div>
  </form>
  <hr />
  <app-events></app-events>
  <hr />
  <app-affiliate></app-affiliate>
  <hr />
  <app-latest-news-section></app-latest-news-section>
</div>